import GoogleAuthenticateWeb from "./GoogleAuthenticateWeb";

export function GoogleAuthProvider() {
    console.log("[GoogleAuthProvider] web");
    return <GoogleAuthenticateWeb />
}
